/* Essence Elite, Produktseite.
   Drei Aufgaben: Galerie umschalten, Staffel wählen (setzt die Menge im
   Warenkorb-Formular), Kaufleiste einblenden, sobald der Knopf oben aus dem
   Bild scrollt. Die Preistexte sind bereits von Liquid gesetzt und stehen als
   data-Attribute im Markup; hier wird nur umgehängt. */
(function () {
  'use strict';

  function init(wurzel) {
    if (wurzel.dataset.eepBereit) return;
    wurzel.dataset.eepBereit = '1';

    /* ── Galerie ── */
    var hauptBild = wurzel.querySelector('[data-eep-haupt]');
    var minis = [].slice.call(wurzel.querySelectorAll('[data-eep-mini]'));
    minis.forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        var gross = knopf.getAttribute('data-gross');
        if (hauptBild && gross) {
          hauptBild.src = gross;
          hauptBild.alt = knopf.getAttribute('data-alt') || hauptBild.alt;
        }
        minis.forEach(function (m) { m.setAttribute('aria-current', String(m === knopf)); });
      });
    });

    /* ── Staffel ──
       Die Preistexte kommen fertig aus Liquid, damit sie exakt dem
       Geldformat des Shops entsprechen. */
    var mengenFeld  = wurzel.querySelector('[data-eep-menge]');
    var knopfText   = wurzel.querySelector('[data-eep-knopftext]');
    var klebeText   = wurzel.querySelector('[data-eep-klebe-text]');
    var klebePreis  = wurzel.querySelector('[data-eep-klebe-preis]');

    function uebernehmen(wahl) {
      if (!wahl) return;
      if (mengenFeld) mengenFeld.value = wahl.getAttribute('data-menge') || '1';
      if (knopfText)  knopfText.textContent  = wahl.getAttribute('data-knopf-text')  || knopfText.textContent;
      if (klebeText)  klebeText.textContent  = wahl.getAttribute('data-klebe-text')  || klebeText.textContent;
      if (klebePreis) klebePreis.textContent = wahl.getAttribute('data-klebe-preis') || klebePreis.textContent;
    }

    var wahlen = [].slice.call(wurzel.querySelectorAll('[data-eep-wahl]'));
    wahlen.forEach(function (w) {
      w.addEventListener('change', function () { if (w.checked) uebernehmen(w); });
    });
    uebernehmen(wahlen.filter(function (w) { return w.checked; })[0] || wahlen[0]);

    /* ── Kaufleiste ──
       Sie erscheint erst, wenn der Knopf im oberen Bereich nicht mehr zu
       sehen ist. Ohne IntersectionObserver bleibt sie einfach aus. */
    var klebe = wurzel.querySelector('[data-eep-klebe]');
    var ankerKnopf = wurzel.querySelector('[data-eep-hauptknopf]');
    if (klebe && ankerKnopf && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (eintraege) {
        klebe.classList.toggle('ist-da', !eintraege[0].isIntersecting);
      }, { threshold: 0 }).observe(ankerKnopf);
    }

    /* Die Leiste schickt dasselbe Formular ab wie der Knopf oben. */
    var klebeKnopf = wurzel.querySelector('[data-eep-klebe-knopf]');
    var formular = wurzel.querySelector('.eep__form');
    if (klebeKnopf && formular) {
      klebeKnopf.addEventListener('click', function () {
        if (formular.requestSubmit) formular.requestSubmit(); else formular.submit();
      });
    }
  }

  function start() { [].slice.call(document.querySelectorAll('[data-eep]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
